<script>
    import { useNavigate } from "svelte-navigator";
    import { onMount } from "svelte";
    import { Moon } from "svelte-loading-spinners";
    import Form from "../components/form/Form.svelte";
    import Params from "../components/form/Params.svelte";
    import Error from "../components/form/Error.svelte";
    import SqlEditor from "../components/form/SqlEdior/editor.svelte"
    import Validators from "../utils/validators";
    import { headerDisplayStore ,validationStore } from "../stores/General";
    import { create, update, getById, getList, checkQuery } from "../api";
    import QueryTotalBuilder from "../components/QueryTotalBuilder.svelte";
    import PlainInput from "../components/form/PlainInput.svelte";
    import InputWrapper from "../components/form/InputWrapper.svelte";

  const navigate = useNavigate();
  const module_name = 'reports';
  const defaultFilter = {
    from_time: '01/01/2020',
    to_time: '01/01/2022',
  };
  const {isValid} = validationStore
  export let id = "";
  // Report data object
  let report = null;
  let queryError;
  let querySyntaxError;
  let querySyntaxErrorMessage = '';
  let checkvalid = '';
  let testQueryLoading = false;
  let testQueryPass = false;
  let testQueryError;
  let testQueryCount;
  // values sent to api
  let filter = {};
  // values sent to form filter
  let filters = [];

  onMount(() => {
    if (id) {
      headerDisplayStore.SetTitle('Edit Report');
      getById(module_name, id)
        .then((response) => {
          if (response?.report.length) {
            report = response.report[0];
          } else {
            headerDisplayStore.ShowError({
              title: 'Error',
              subtitle: response?.error,
            });
            navigate('/report');
          }
        })
        .catch((error) => {
          headerDisplayStore.ShowError({
            title: 'Server error',
            subtitle: error?.message,
          });
          navigate('/report');
        });
    } else {
      headerDisplayStore.SetTitle('New Report');
    }
    headerDisplayStore.SetBreadCrumbs([
      {
        key: 'report',
        label: 'Report',
      },
      {
        key: 'new',
        label: 'New',
      },
    ]);
  });

  let form;
  let rules = {
    title: {
      validators: [Validators.required, Validators.minLength(4)],
    },
    query: {
      validators: [Validators.required, Validators.minLength(4)],
    },
  };
  let title = '';
  let query = '';
  let summaryQueryError = '';
  let basetitle = '';
  let isExist = false;
  let params = [{ name: null, value: null }];

  async function fetchDemandPartners(name = undefined) {
    try {
      const response = await getList('demand', 10, 1, 'name', 'ASC', { name });
      if (response?.data) {
        return response.data.map((item) => ({ value: item.demand_partner_id, label: item.name }));
      }
      return [];
    } catch (error) {
      console.warn(error);
      return [];
    }
  }

  async function fetchIabList(search = undefined) {
    try {
      const response = await getList('iab/category', 10, 1, 'name', 'ASC', { search });
      if (response?.data) {
        return response.data.map((item) => ({ value: item.iab_category_id, label: item.name }));
      }
      return [];
    } catch (error) {
      console.warn(error);
      return [];
    }
  }

  async function fetchCampaigns(search = undefined) {
    try {
      const response = await getList('campaign', 10, 1, 'name', 'ASC', { name: search });
      if (response?.data) {
        return response.data.map((item) => ({ value: item.campaign_id, label: item.name }));
      }
      return [];
    } catch (error) {
      console.warn(error);
      return [];
    }
  }

  function onReportQueryChange(event) {
    query = event.detail;
    if (query) {
      query = query;
      validateQuery(query);
      let getError = validateQuerySyntax(query);
      querySyntaxError = getError?.querySyntaxError;
      querySyntaxErrorMessage = getError?.querySyntaxErrorMessage;
    }
  }

  function checkReportTitle(event) {
    title = event.detail.target.value;
    let pageSize = 1;
    let page = 1;
    let sortBy = 'title';
    let sortOrder = 'ASC';
    let filter = { title: title };

    if (title) {
      if (title === basetitle) {
        isExist = false;
      } else {
        getList(module_name, pageSize, page, sortBy, sortOrder, filter)
          .then((response) => {
            if (response?.count > 0) {
              isExist = response.data.some((el) => el.title.toLowerCase() == title.toLowerCase());
            } else {
              isExist = false;
            }
          })
          .catch((error) => {
            isExist = false;
          });
      }
    }
  }
  function validateQuery(query) {
    queryError = /.*(limit|offset)[\s()]+[\d]{1,}/gi.test(query);
  }
  function validateQuerySyntax(query) {
    //set interactive message based on regex validation
    if (!/select\s+(.*?)/gi.test(query)) {
      //check for select keyword
      return {
        querySyntaxError: true,
        querySyntaxErrorMessage: 'Syntax Error, Syntax should begin with select.',
      };
    } else if (!/\s*from\s+(.*?)/gi.test(query)) {
      testQueryPass = false;
      //check for from keyword
      return {
        querySyntaxError: true,
        querySyntaxErrorMessage: "Syntax Error, Syntax should contain 'from'.",
      };
    } else if (!/\s*((.*?)\s*)?;/gi.test(query)) {
      testQueryPass = false;
      //check closing tag ;  keyword which is required
      return {
        querySyntaxError: true,
        querySyntaxErrorMessage: 'Syntax Error, Please end the statement with ;',
      };
    } else if (!/select\s+(.*?)\s*from\s+(.*?)\s*(where\s(.*?)\s*)?;/gi.test(query)) {
      testQueryPass = false;
      return {
        querySyntaxError: true,
        querySyntaxErrorMessage: 'Syntax Error, Please check your query.',
      };
    } else {
      return { querySyntaxError: false, querySyntaxErrorMessage: '' };
    }
  }
  function paramsToFilters(params = []) {
    params = report?.params == undefined ? params : JSON.parse(report?.params);
    const _filters = [];

    params.map((param) => {
      // prepare ui filter and set initial value from params
      const _filter = {
        label: param.display_name,
        key: param.param_name,
        filter: param.type,
        value: param.default_value || defaultFilter?.[param.param_name],
      };
      if (param.param_name == 'from_time' || param.param_name == 'to_time') {
        _filter.filter = 'date_single';
      }
      if (param.type === 'dp_list') {
        _filter.getItems = fetchDemandPartners;
        _filter.filter = 'list';
      }
      if (param.type === 'iab_list') {
        _filter.getItems = fetchIabList;
        _filter.filter = 'list';
      }
      if (param.type === 'campaign_list') {
        _filter.getItems = fetchCampaigns;
        _filter.filter = 'list';
      }
      // TODO: add campaigns
      // update api filter with initial value from ui filter
      filter[param.param_name] = _filter.value;
      filter = filter;
      // dropdowns have object value
      // we only have initial value, use it as label too
      if (_filter.filter === 'list') {
        _filter.value = { value: _filter.value, label: _filter.value };
      }
      // add this to list of ui filters
      _filters.push(_filter);
    });
    return _filters;
  }
  function onSubmit(e) {
    if (e?.detail?.valid && !queryError) {
      if (id) {
        update(module_name, e.detail.data)
          .then((response) => {
            if (response?.status === 'ok') {
              headerDisplayStore.ShowNotification({
                title: 'Success',
                subtitle: 'Report saved successfully',
              });
              navigate('/report');
            } else {
              headerDisplayStore.ShowError({
                title: 'Error',
                subtitle: response?.error,
              });
            }
          })
          .catch((error) => {
            headerDisplayStore.ShowError({
              title: 'Server error',
              subtitle: error?.message,
            });
          });
      } else {
        create(module_name, e.detail.data)
          .then((response) => {
            if (response?.status === 'ok') {
              headerDisplayStore.ShowNotification({
                title: 'Success',
                subtitle: 'Report saved successfully',
              });
              navigate('/report');
            } else {
              headerDisplayStore.ShowError({
                title: 'Error',
                subtitle: response?.error,
              });
            }
          })
          .catch((error) => {
            headerDisplayStore.ShowError({
              title: 'Server error',
              subtitle: error?.message,
            });
          });
      }
    } else {
      console.log('Invalid Form');
    }
  }

  function TestValidateQuery() {
    testQueryLoading = true;
    const _filters = paramsToFilters(params);
    filters = _filters;
    let newData = {
      query: query || report?.query, //this value might come from the form or database
      filter,
      //check if report id exist, if it exist, use the params from the db else pick the params from the form
      params:
        report?.params == undefined
          ? params[0]?.param_name == null || ''
            ? ''
            : params
          : JSON.parse(report?.params),
    };
    checkQuery(newData)
      .then((response) => {
        if (response?.status === 'ok') {
          testQueryLoading = false;
          testQueryError = false;
          testQueryCount = response?.count;
          testQueryPass = true;
        } else {
          testQueryLoading = false;
          testQueryError = true;
          testQueryPass = false;
        }
      })
      .catch((error) => {
        console.log(error);
        testQueryLoading = false;
        testQueryError = true;
        testQueryPass = false;
      });
  }
  isValid.subscribe((value) => {
    checkvalid = value;
  });
  $: isEmpty = !title || !query;

  function handleReportSummaryChange(event) {
    summaryQueryError = event.detail.error;
  }


  function handleParamsChange(e) {
    params = e.detail;
  }

</script>

<div class="rounded">
  {#if !id || (id && report)}
    <Form {rules} on:submit={onSubmit} bind:this={form}>
      {#if id}
        <PlainInput name="report_id" type="hidden" value={id} />
      {/if}
      <div class="py-6">
        <div class="w-10/12 mx-auto px-4 py-4 sm:px-6 sm:py-6 md:px-8 md:py-8 bg-white rounded-2xl">
          {#if !id}
            <div class="text-2xl pt-6">Add New Report</div>
          {/if}
          <div class="flex w-full">
            <div class="flex flex-col items-center w-full mr-2">
              <InputWrapper label="Report Title" required={true}>
                <PlainInput
                  name="title"
                  value={title || report?.title}
                  on:debounce={checkReportTitle}
                />
              </InputWrapper>
            </div>
          </div>
          {#if id && report?.params}
            <div class="mt-4">
              <Params
                name="params"
                on:change={handleParamsChange}
                params={Array.isArray(JSON.parse(report?.params)) &&
                JSON.parse(report?.params).length
                  ? JSON.parse(report.params)
                  : [{ name: '', value: '' }]}
              />
            </div>
          {:else}
            <div class="mt-4">
              <Params name="params" bind:params />
            </div>
          {/if}
          <div class="flex flex-col items-center">
            <!-- <TextArea
                            label="Query Builder"
                            name="query"
                            value={query}
                            initialValue={report?.query}
                        /> -->
            <SqlEditor
              label="Query Builder"
              on:querying={onReportQueryChange}
              name="query"
              query={report?.query}
              params={report?.params && Array.isArray(JSON.parse(report?.params))
                ? JSON.parse(report.params).map((el) => el.name)
                : params.map((el) => el.name)}
            />
            <Error fieldName="query" errorKey="minLength" />
          </div>
          <button
            type="button"
            on:click={TestValidateQuery}
            disabled={testQueryLoading || querySyntaxError}
            class={`w-48 h-8 relative inline-flex items-center justify-center float-right ml-2 ${
              testQueryLoading ? 'bg-custom-gray' : 'bg-custom-query-button'
            } hover: text-white text-sm font-bold rounded px-2 py-1`}
          >
            <span>
              <div class="flex flex-row ...">
                <div>
                  {#if testQueryLoading}
                    <Moon size="1" color="#FFFF" unit="rem" duration="1s" />
                  {/if}
                </div>
                <div>{testQueryLoading ? ` Loading..` : 'Test Query'}</div>
              </div>
            </span>
          </button>
          {#if queryError}
            <p class="text-red-500 text-xs">
              Query should not contain <strong>limit</strong> and
              <strong>offset</strong> parameters. These will be automatically added
            </p>
          {/if}
          {#if query && querySyntaxError}
            <p class="text-red-500 text-xs">
              {querySyntaxErrorMessage}
            </p>
          {/if}
          {#if query && testQueryError}
            <p class="text-red-500 text-xs">The query wasnt successfully completed.</p>
          {/if}
          {#if testQueryPass && !queryError && !querySyntaxError}
            <p class="text-green-500 text-xs">
              The query was successfully completed with {testQueryCount} results.
            </p>
          {/if}
          <QueryTotalBuilder
            id="editor2"
            on:change={handleReportSummaryChange}
            {params}
            query={report?.summary_query}
            {filter}
          />

          <!--  -->
          <div class="pt-4">
            <div />
            <div />
          </div>
        </div>
      </div>
      <div class="flex flex-row justify-end gap-4 mt-8 w-10/12 mx-auto">
        {#if id}
          <button
            type="submit"
            disabled={querySyntaxError || summaryQueryError || testQueryError}
            class="w-48 h-12 relative inline-flex items-center justify-center px-1 py-1 rounded-md border shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
          >
            <span>Update</span>
          </button>
        {:else}
          <button
            type="submit"
            disabled={isEmpty || isExist || querySyntaxError || summaryQueryError || testQueryError}
            class="w-48 h-12 relative inline-flex items-center justify-center px-1 py-1 rounded-md border shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
          >
            <span>Create</span>
          </button>
        {/if}
        <button
          on:click={() => {
            navigate('/report');
          }}
          type="button"
          class="w-40 h-12 relative inline-flex items-center justify-center px-1 py-1 rounded-md border shadow-nv border-custom-orange  text-sm font-medium text-custom-orange focus:text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
        >
          <span>Cancel</span>
        </button>
      </div>
    </Form>
  {:else}
    <div class="min-w-full loader-container text-center">
      <div class="align-middle inline-block h-16">
        <Moon size="4" color="#FF3E00" unit="rem" duration="1s" />
      </div>
      <div class="align-middle inline-block h-full" />
    </div>
  {/if}
</div>
